const updateNormalizedData = (object, intialData, key = 'customId') => {
  let byId = intialData && intialData.byId ? intialData.byId : {}
  byId[object[key]] = { ...byId[object[key]], ...object }
  intialData = { ...intialData, byId }
  return intialData
}

export default updateNormalizedData
